import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';
import { RouteContext } from '@townsquare/router/routing-types';

export const AgentsViewLoadable: ComponentType<RouteContext> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "agents-view" */ './AgentsView'),
	loading: () => null,
});

export const BrowseAgentsViewLoadable: ComponentType<RouteContext> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "browse-agents-view" */ './BrowseAgentsView'),
	loading: () => null,
});
